import React, { useRef, useEffect, useState } from 'react';
import { SwipeableHandlers } from 'react-swipeable';
import { useSelector } from 'react-redux';
import { Slide } from '@material-ui/core';

import MediaPreviewStyles from './styles';
import { selectMediaViewer } from '../../store/modules/media-viewer/selectors';
import { Spinner } from '../../components';

import { Media } from '../../store/modules/media-viewer/types';

type Props = {
  media: Media;
  swipeable?: SwipeableHandlers;
  slideDirection: 'left' | 'right' | 'up' | 'down';
  isChangePreviewMedia: number | null;
};

const MediaPages = ({ swipeable, slideDirection, isChangePreviewMedia }: Props) => {
  const classes = MediaPreviewStyles();
  const imageRef = useRef<HTMLImageElement>(null);
  const [isLoading, setIsloading] = useState(true);
  const { currentDocumentPage, documentPageList, loading } = useSelector(selectMediaViewer);
  const documentPage = documentPageList[currentDocumentPage];

  useEffect(
    () => {
      setIsloading(true);
    },
    [setIsloading, currentDocumentPage],
  );

  if (!documentPage || loading) {
    return (
      <Slide
        direction={slideDirection}
        in={isChangePreviewMedia === null}
        mountOnEnter
        unmountOnExit
      >
        <div {...swipeable} className={classes.wrapper}>
          <Spinner />
        </div>
      </Slide>
    );
  }

  return (
    <Slide
      direction={slideDirection}
      in={isChangePreviewMedia === null}
      mountOnEnter
      unmountOnExit
      timeout={300}
    >
      <div {...swipeable} className={classes.wrapper}>
        {isLoading && <Spinner />}
        <img
          hidden={isLoading}
          ref={imageRef}
          src={documentPage?.url?.url || ''}
          alt=""
          className={classes.image}
          onLoad={() => setIsloading(false)}
          onLoadCapture={() => setIsloading(true)}
        />
      </div>
    </Slide>
  );
};

export default MediaPages;
